// AUTO-GENERATED — DO NOT EDIT
// Generated from generated.ts by tools/scripts/generate-zod-schemas.js

import * as z from 'zod';

export const PriceViewSchema = z.object({
  id: z.number(),
  price: z.string(),
  tax: z.string(),
  valid_from: z.string(),
});

export const DefectMediaViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  mime_type: z.string(),
  size: z.number(),
});

export const AdditionalProductViewSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
  type: z.string(),
  is_universal: z.boolean(),
  linked_product_ids: z.array(z.any()),
  current_price: PriceViewSchema.nullable(),
  prices: z.array(z.any()),
  hero_image: DefectMediaViewSchema.nullable(),
});

export const AdminVoucherViewSchema = z.object({
  id: z.number(),
  order_id: z.number().nullable(),
  product_id: z.number().nullable(),
  code: z.string(),
  voucher_type: z.string().nullable(),
  value: z.string(),
  remaining_credit: z.string(),
  valid_from: z.string(),
  valid_until: z.string(),
  note: z.string().nullable(),
  text_salutation: z.string().nullable(),
  text_greeting: z.string().nullable(),
  text_sender: z.string().nullable(),
  created_at: z.string(),
});

export const AvailabilitySlotViewSchema = z.object({
  slot_start: z.string(),
  slot_end: z.string(),
  available_total: z.number(),
  available_instruction: z.number(),
  base_total: z.number(),
  base_instruction: z.number(),
});

export const BookingViewSchema = z.object({
  id: z.number(),
  order_id: z.number(),
  order_number: z.string().nullable(),
  contingent_id: z.number(),
  contingent_title: z.string().nullable(),
  from: z.string(),
  until: z.string(),
  quantity: z.number(),
  quantity_instruction: z.number(),
  created_at: z.string(),
});

export const CartAvailabilitySlotViewSchema = z.object({
  slot_start: z.string(),
  slot_end: z.string(),
  available_total: z.number(),
  available_instruction: z.number(),
  base_total: z.number(),
  base_instruction: z.number(),
  required_total: z.number(),
  required_instruction: z.number(),
  bookable: z.boolean(),
  status: z.string(),
  reason: z.string().nullable(),
});

export const PerTicketViewSchema = z.object({
  ticket_id: z.number(),
  quantity: z.number(),
  unit_price: z.string(),
  is_included: z.boolean(),
});

export const OrderLineItemViewSchema = z.object({
  index: z.number(),
  kind: z.string(),
  product_id: z.number().nullable(),
  contingent_id: z.number().nullable(),
  slot_start: z.string().nullable(),
  slot_end: z.string().nullable(),
  quantity: z.number().nullable(),
  quantity_instruction: z.number().nullable(),
  unit_price: z.string().nullable(),
  tax: z.string().nullable(),
  value: z.string().nullable(),
  text_salutation: z.string().nullable(),
  text_greeting: z.string().nullable(),
  text_sender: z.string().nullable(),
  per_ticket: z.array(PerTicketViewSchema),
  update_url: z.string().nullable(),
  delete_url: z.string().nullable(),
});

export const CartViewSchema = z.object({
  order_id: z.number(),
  expires_at: z.string(),
  cart_view_url: z.string(),
  submit_url: z.string(),
  vouchers_validate_url: z.string(),
  cart_destroy_url: z.string(),
  cart_add_item_url: z.string(),
  line_items: z.array(OrderLineItemViewSchema),
  totals: z.any(),
});

export const CategoryViewSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
  contingent_id: z.number().nullable(),
  hero_image: DefectMediaViewSchema.nullable(),
});

export const CheckpointJourneyRefViewSchema = z.object({
  id: z.number(),
  device_id: z.string().nullable(),
});

export const CheckpointRouteRefViewSchema = z.object({
  name: z.string().nullable(),
});

export const CheckpointStationRefViewSchema = z.object({
  designation: z.string().nullable(),
});

export const CheckpointViewSchema = z.object({
  id: z.number(),
  tag_name: z.string(),
  belt_name: z.string(),
  created_at: z.string().nullable(),
  journey: CheckpointJourneyRefViewSchema.nullable(),
  route: CheckpointRouteRefViewSchema.nullable(),
  station: CheckpointStationRefViewSchema.nullable(),
});

export const ContentViewSchema = z.object({
  id: z.number(),
  type: z.string(),
  valid_from: z.string().nullable(),
  valid_until: z.string().nullable(),
  rank: z.number(),
  layout_config: z.array(z.any()).nullable(),
  language: z.string(),
  headline: z.string().nullable(),
  text: z.string().nullable(),
  cta_text: z.string().nullable(),
  cta_link: z.string().nullable(),
  image: DefectMediaViewSchema.nullable(),
});

export const ContingentViewSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
  total_amount: z.number(),
  instruction_amount: z.number(),
});

export const UserRefViewSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const ControlPointCheckinViewSchema = z.object({
  id: z.number(),
  control_point_id: z.number(),
  control_point_name: z.string().nullable(),
  user: UserRefViewSchema.nullable(),
  checked_in_at: z.string(),
});

export const ControlPointStatusViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  interval_minutes: z.number(),
  tag_name: z.string(),
  status: z.string(),
  last_checked_in_at: z.string().nullable(),
  due_at: z.string().nullable(),
});

export const QualificationViewSchema = z.object({
  id: z.number(),
  name: z.string().max(255),
  description: z.string().nullable(),
  users: z.array(UserRefViewSchema),
});

export const ControlPointViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  interval_minutes: z.number(),
  tag_name: z.string(),
  required_qualifications: z.array(QualificationViewSchema),
});

export const DashboardSlotViewSchema = z.object({
  contingent_id: z.number(),
  contingent_title: z.string(),
  slot_start: z.string(),
  slot_end: z.string(),
  capacity_total: z.number(),
  capacity_instruction: z.number(),
  used_total: z.number(),
  used_instruction: z.number(),
  is_overbooked: z.boolean(),
});

export const DashboardStatusViewSchema = z.object({
  capacity_total: z.number(),
  used_total: z.number(),
  free_upcoming_instruction_slots: z.number(),
});

export const DayDashboardViewSchema = z.object({
  date: z.string(),
  orders: z.array(z.any()),
  slots: z.array(DashboardSlotViewSchema),
  status: DashboardStatusViewSchema,
});

export const DefectCheckinViewSchema = z.object({
  id: z.number(),
  defect_id: z.number(),
  user: UserRefViewSchema.nullable(),
  checked_in_at: z.string(),
  checked_out_at: z.string().nullable(),
});

export const DefectCommentViewSchema = z.object({
  id: z.number(),
  comment: z.string(),
  datetime: z.string().nullable(),
  user: UserRefViewSchema.nullable(),
});

export const DefectViewSchema = z.object({
  id: z.number(),
  title: z.string().max(255),
  description: z.string().nullable(),
  model_type: z.string(),
  model_id: z.string().max(255),
  model_name: z.string(),
  reporting_time: z.string().nullable(),
  status: z.string(),
  priority: z.string().nullable(),
  due_date: z.string().nullable(),
  estimated_repair_time: z.number().nullable(),
  repair_timing: z.string().nullable(),
  responsible_user: UserRefViewSchema.nullable(),
  reporter: UserRefViewSchema.nullable(),
  comments: z.array(z.any()),
  media: z.array(z.any()),
  checkins: z.array(z.any()),
});

export const EyeCatcherViewSchema = z.object({
  id: z.number(),
  image: z.string(),
  url: z.string(),
  valid_from: z.string().nullable(),
  valid_until: z.string().nullable(),
});

export const InspectionModelViewSchema = z.object({
  id: z.number(),
  model_type: z.string(),
  model_id: z.string(),
  name: z.string(),
  type: z.string(),
  item_id: z.string(),
  section_type: z.string().nullable(),
  checked_at: z.string().nullable(),
});

export const InspectionViewSchema = z.object({
  id: z.number(),
  name: z.string().max(255),
  date: z.string(),
  status: z.number(),
  models: z.array(InspectionModelViewSchema),
});

export const JourneyHistoryDayViewSchema = z.object({
  date: z.string(),
  points: z.number(),
  stats: z.array(z.any()),
});

export const JourneyHistoryStatsViewSchema = z.object({
  parcours: z.number(),
  height: z.number(),
  length: z.number(),
  duration: z.string(),
  ropewayMeters: z.number(),
});

export const JourneyStatsViewSchema = z.object({
  duration: z.string(),
  height: z.number(),
  length: z.number(),
  ropewayMeters: z.number(),
  parcours: z.number(),
  points: z.number(),
});

export const JourneyViewSchema = z.object({
  id: z.number(),
  user_id: z.number().nullable(),
  device_id: z.string(),
  tag_name: z.string(),
  start_time: z.string().nullable(),
  end_time: z.string().nullable(),
  nickname: z.string().nullable(),
});

export const OpeningHourTypeViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  public: z.boolean(),
  opening_hours: z.array(z.any()),
});

export const OpeningHourViewSchema = z.object({
  id: z.number(),
  opening_hour_type_id: z.number(),
  type: z.string(),
  date_start: z.string(),
  date_end: z.string().nullable(),
  time_start_mon: z.string().nullable(),
  time_end_mon: z.string().nullable(),
  time_start_tue: z.string().nullable(),
  time_end_tue: z.string().nullable(),
  time_start_wed: z.string().nullable(),
  time_end_wed: z.string().nullable(),
  time_start_thu: z.string().nullable(),
  time_end_thu: z.string().nullable(),
  time_start_fri: z.string().nullable(),
  time_end_fri: z.string().nullable(),
  time_start_sat: z.string().nullable(),
  time_end_sat: z.string().nullable(),
  time_start_sun: z.string().nullable(),
  time_end_sun: z.string().nullable(),
  time_start: z.string().nullable(),
  time_end: z.string().nullable(),
  notes: z.string().nullable(),
});

export const OrderAdminViewSchema = z.object({
  id: z.number(),
  order_number: z.string(),
  status: z.string(),
  payment_method: z.string().nullable(),
  payment_status: z.string(),
  source: z.string(),
  expires_at: z.string().nullable(),
  payment_incident_reason: z.string().nullable(),
  payment_incident_at: z.string().nullable(),
  deleted_at: z.string().nullable(),
  customer: z.any().nullable(),
  line_items: z.array(OrderLineItemViewSchema),
  totals: z.any(),
  voucher_applied: z.any().nullable(),
  content: z.any(),
  notes: z.string().nullable(),
  bookings: z.array(BookingViewSchema),
  vouchers: z.array(AdminVoucherViewSchema),
  created_at: z.string(),
  updated_at: z.string(),
});

export const OrderViewSchema = z.object({
  id: z.number(),
  order_number: z.string(),
  status: z.string(),
  payment_method: z.string().nullable(),
  payment_status: z.string(),
  source: z.string(),
  expires_at: z.string().nullable(),
  customer: z.any().nullable(),
  line_items: z.array(OrderLineItemViewSchema),
  totals: z.any(),
  voucher_applied: z.any().nullable(),
  created_at: z.string(),
  payment_url: z.string().nullable(),
});

export const PermissionViewSchema = z.object({
  name: z.string().nullable(),
});

export const ProductDetailViewSchema = z.object({
  id: z.number(),
  product_id: z.number(),
  language: z.string(),
  title: z.string(),
  description_short: z.string(),
  description_long: z.string(),
});

export const ProductViewSchema = z.object({
  id: z.number(),
  category_id: z.number(),
  contingent_id: z.number().nullable(),
  opening_hour_type_id: z.number(),
  key: z.string(),
  duration: z.number().nullable(),
  interval: z.number().nullable(),
  for_request: z.boolean().nullable(),
  active: z.boolean(),
  detail: ProductDetailViewSchema.nullable(),
  details: z.array(z.any()),
  current_price: PriceViewSchema.nullable(),
  display_price: z.number().nullable(),
  hero_image: DefectMediaViewSchema.nullable(),
  tickets: z.array(z.any()),
  additional_products: z.array(z.any()),
  opening_hour_type: OpeningHourTypeViewSchema.nullable(),
  prices: z.array(z.any()),
  has_included_tickets: z.boolean(),
});

export const PsaOptionViewSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const PsaViewSchema = z.object({
  id: z.string(),
  type: z.string(),
  tags: z.array(z.string()),
  last_checked_at: z.string().nullable(),
  manufacturer_number_set: z.string().nullable(),
  manufacturer_number_harness: z.string().nullable(),
  manufacturer_number_carabiners: z.string().nullable(),
  has_defects: z.boolean(),
  open_defect_count: z.number(),
});

export const RankingEntryViewSchema = z.object({
  position: z.any(),
  nickname: z.string(),
  total_points: z.number().nullable(),
  total_parcours: z.number().nullable(),
  total_length: z.number().nullable(),
  total_height: z.number().nullable(),
  total_ropeway_meters: z.number().nullable(),
  is_current_user: z.boolean(),
  is_separator: z.boolean(),
});

export const RoleUserViewSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  permissions: z.array(z.any()).nullable(),
  roles: z.array(z.any()).nullable(),
});

export const RoleViewSchema = z.object({
  name: z.string().nullable(),
  permissions: z.array(z.any()).nullable(),
});

export const RouteOptionViewSchema = z.object({
  id: z.number(),
  name: z.string(),
  sections: z.array(z.any()),
});

export const RouteSectionViewSchema = z.object({
  id: z.string(),
  route_id: z.number(),
  name: z.string(),
  type: z.string(),
  order: z.number(),
  last_checked_at: z.string().nullable(),
  has_defects: z.boolean(),
});

export const SlotReportContingentViewSchema = z.object({
  id: z.number(),
  title: z.string(),
  total_amount: z.number(),
  instruction_amount: z.number(),
});

export const SlotReportHourViewSchema = z.object({
  from: z.string(),
  until: z.string(),
  fest_total: z.number(),
  fest_instruction: z.number(),
  tmp_total: z.number(),
  tmp_instruction: z.number(),
  bookings: z.array(BookingViewSchema),
});

export const SlotReportRangeViewSchema = z.object({
  contingent: SlotReportContingentViewSchema,
  hours: z.array(SlotReportHourViewSchema),
});

export const TicketDetailViewSchema = z.object({
  id: z.number(),
  ticket_id: z.number(),
  language: z.string(),
  title: z.string(),
});

export const TicketViewSchema = z.object({
  id: z.number(),
  product_id: z.number(),
  min_amount: z.number().nullable(),
  max_amount: z.number().nullable(),
  is_included: z.boolean(),
  detail: TicketDetailViewSchema.nullable(),
  details: z.array(z.any()),
  current_price: PriceViewSchema.nullable(),
  prices: z.array(z.any()),
});

export const TaskCommentViewSchema = z.object({
  id: z.number(),
  comment: z.string(),
  datetime: z.string().nullable(),
  user: UserRefViewSchema.nullable(),
});

export const TaskExecutionViewSchema = z.object({
  id: z.number(),
  task_id: z.number(),
  due_at: z.string().nullable(),
  status: z.string(),
  completed_at: z.string().nullable(),
  completed_by: UserRefViewSchema.nullable(),
  approved_at: z.string().nullable(),
  approved_by: UserRefViewSchema.nullable(),
  missed_count: z.number(),
  is_overdue: z.boolean(),
});

export const TaskViewSchema = z.object({
  id: z.number(),
  title: z.string().max(255),
  description: z.string().nullable(),
  priority: z.string().nullable(),
  estimated_time: z.number().nullable(),
  requires_approval: z.boolean(),
  recurrence_unit: z.string().nullable(),
  recurrence_every: z.number().nullable(),
  is_recurring: z.boolean(),
  responsible_user: UserRefViewSchema.nullable(),
  creator: UserRefViewSchema.nullable(),
  created_at: z.string().nullable(),
  current_execution: TaskExecutionViewSchema.nullable(),
  executions: z.array(z.any()),
  comments: z.array(z.any()),
  media: z.array(z.any()),
});

export const TaskExecutionListItemViewSchema = z.object({
  execution: TaskExecutionViewSchema,
  task: TaskViewSchema,
});

export const UserCompanyViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  zip: z.string().nullable(),
  countryIso: z.string().nullable(),
});

export const UserLoginViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  company: z.any().nullable(),
  active: z.number(),
  permissions: z.array(z.any()),
  roles: z.array(z.any()),
});

export const UserViewSchema = z.object({
  id: z.string(),
  email: z.string(),
  salutation: z.string().nullable(),
  active: z.number(),
  name: z.string(),
  title: z.string().nullable(),
  createdAt: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  company: z.any().nullable(),
  companyId: z.number().nullable(),
  roles: z.array(z.any()),
  hasPassword: z.boolean(),
});

export const VoucherViewSchema = z.object({
  valid: z.boolean(),
  reason: z.string().nullable(),
  remaining_credit: z.string().nullable(),
  valid_until: z.string().nullable(),
});
